<template>
  <h2 class="align-center bottom-1">{{ title }}</h2>
</template>

<script>
export default {
    props: ['title']
}
</script>

<style>

</style>